import React from 'react';
import MultiItemCarousel from '../../common/components/MultiItemCarousel';

const PersonalizedPicksCarousel = ({
  products = [],
  loading = false,
  error = null,
  sectionTitle = 'Personalised picks',
  clientKey,
  currentQuery,
}) => {
  const items = Array.isArray(products)
    ? products.map((p, idx) => ({ id: p.id || idx, title: p.name || `Item ${idx + 1}`, image: p.image, url: p.url || p.url_key, url_key: p.url_key }))
    : [];

  return (
    <div className="sticky top-4">
      <h3 className="text-lg font-semibold text-gray-800 mb-3">{sectionTitle}</h3>

      {loading && <div className="text-sm text-gray-500">Loading products...</div>}

      {!loading && error && <div className="text-sm text-red-500">{error}</div>}

      {!loading && !error && (!items || items.length === 0) && (
        <div className="text-sm text-gray-400">No personalised products yet</div>
      )}

      {!loading && !error && items && items.length > 0 && (
        <MultiItemCarousel
          orientation="vertical"
          itemsPerGroup={3}
          autoAdvanceTime={5000}
          items={items}
          query={currentQuery}
          clientKey={clientKey}
        />
      )}
    </div>
  );
};

export default PersonalizedPicksCarousel;
